import { render, staticRenderFns } from "./ModuleTitle.vue?vue&type=template&id=03e7a9a6&scoped=true&"
import script from "./ModuleTitle.vue?vue&type=script&lang=js&"
export * from "./ModuleTitle.vue?vue&type=script&lang=js&"
import style0 from "./ModuleTitle.vue?vue&type=style&index=0&id=03e7a9a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e7a9a6",
  null
  
)

export default component.exports